import classNames from 'classnames';
import React from 'react';
import { CustomArrowProps } from 'react-slick';

import * as styles from './CarouselArrow.css';

// используется для скрытия стрелок по ховеру на карточку, для улучшения производительности
import * as hoverStyles from '../../../../../fragments/OfferCardWidget/shared/components/Card/CardHover.css';

import { ArrowL12, ArrowR12 } from '@cian/ui-kit/icons';

export enum EDirection {
  Left = 'left',
  Right = 'right',
}

interface ICarouselArrowProps extends CustomArrowProps {
  direction: EDirection;
}

export const CarouselArrow: React.FC<ICarouselArrowProps> = props => {
  const { direction, onClick } = props;

  const className = classNames(
    styles['container'],
    hoverStyles['gallery-arrow'],
    direction === EDirection.Left && styles['container--left'],
    direction === EDirection.Right && styles['container--right'],
  );

  const Icon = direction === EDirection.Left ? ArrowL12 : ArrowR12;

  const onClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();

    /* istanbul ignore else */
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button className={className} onClick={onClickHandler}>
      <Icon color="white_100" />
    </button>
  );
};
